var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.8555 6V9L16.8555 5L12.8555 1V4C8.43547 4 4.85547 7.58 4.85547 12C4.85547 13.57 5.31547 15.03 6.09547 16.26L7.55547 14.8C7.10547 13.97 6.85547 13.01 6.85547 12C6.85547 8.69 9.54547 6 12.8555 6ZM19.6155 7.74L18.1555 9.2C18.5955 10.04 18.8555 10.99 18.8555 12C18.8555 15.31 16.1655 18 12.8555 18V15L8.85547 19L12.8555 23V20C17.2755 20 20.8555 16.42 20.8555 12C20.8555 10.43 20.3955 8.97 19.6155 7.74Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
